<template>
  <div class='week atb-flex atb-flex-column'>
    <div class='atb-content-bg header atb-flex atb-flex-items-center'>
      <div class='year-no'>
        {{summaryData.year || ''}}
      </div>
      <div class='week-title'>
        <h2>{{summaryData.title || ''}}</h2>
        <p>{{summaryData.creationTime? formatDate(new Date(summaryData.creationTime), 'yyyy-MM-dd HH:mm:ss'): ''}}</p>
      </div>
      <div class='week-right atb-flex atb-flex-justify-between atb-flex-items-center'>
        <div class='week-name'>
          <h2>{{summaryData.resWkName || ''}} <span>{{summaryData.resWkNo || ''}}</span></h2>
          <p>{{summaryData.department || ''}}</p>
        </div>
        <div class='week-operation'>
          <el-form :inline="true" class="atb-input">
            <el-form-item>
            <el-button type="add" @click="addData">新增</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submit">发布</el-button>
          </el-form-item>
        </el-form>
        </div>
      </div>
    </div>
    <div class='container atb-content-bg atb-flex atb-flex-column'>
      <div class='tab'>
        <tab-pane :tab-list="tabList" iconStyle="top" @getCurrent="getCurrent"></tab-pane>
      </div>
      <div v-if="currentTab === 0" class='table-content atb-flex atb-flex-column'>
        <vxe-table
          class='atb-table header-table edit-table'
          border='full'
          height='100%'
          auto-resize
          resizable
          :data="tableData"
          ref="planMonth"
          @checkbox-change="handledSelectChange"
          @checkbox-all="selectAllEvent"
          :edit-config="{trigger: 'click', mode: 'row'}"
          @edit-closed="editClosed"
        >
          <vxe-table-column type='checkbox' width='40' align='center'></vxe-table-column>
          <vxe-table-column type='seq' width='48' align='center' title="序号"></vxe-table-column>
           <!-- <vxe-table-column field="workItemNo" title="NO." :edit-render="{autofocus: '.el-textarea__inner', enabled: disabled}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.workItemNo"></el-input>
            </template>
          </vxe-table-column> -->
          <vxe-table-column field="workClassify" title="工作属性" :edit-render="{name: 'ElSelect', enabled: disabled, autofocus: '.el-input__inner'}">
            <template #default="{row}">
              <span v-if='row.workClassify == 0'>KPI工作</span>
              <span v-if='row.workClassify == 10'>例行工作</span>
              <span v-if='row.workClassify == 20'>问题及创新工作</span>
              <span v-if='row.workClassify == 30'>其他新增工作</span>
            </template>
            <template #edit="scope">
              <el-select v-model='scope.row.workClassify' @change="$refs.week.updateStatus(scope)">
                <el-option v-for="item in classifyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </template>
          </vxe-table-column>

          <vxe-table-column field="workItemCategory" title="类别" :edit-render="{name: 'ElSelect', enabled: disabled, autofocus: '.el-input__inner'}">
            <template #edit="scope">
              <el-select v-model='scope.row.workItemCategory' @change="$refs.week.updateStatus(scope)">
                <el-option v-for="item in categoryList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemContent" title="工作项目" :edit-render="{name: 'ElAutocomplete', enabled: disabled, autofocus: '.el-input__inner'}">
            <template #edit="{ row }">
              <el-autocomplete v-model="row.workItemContent" :fetch-suggestions="querySearch"></el-autocomplete>
            </template>
            <template #default="scope">
              <template>
                <span>{{scope.row.workItemContent}}</span>
              </template>
            </template>
          </vxe-table-column>
          <vxe-table-column field="resWkName" title="指定人" :edit-render="{autofocus: '.el-textarea__inner', enabled: disabled}">
            <template #edit="{ row }">
              <selecter v-model="row.resWkNo" @selecterData="getSelecterData" :jobNo="row.resWkNo" :name="row.resWkName"></selecter>
             <!-- <common-select v-model="row.resWkNo" :list="resWk" optLabel="name" optValue="userName" clearable></common-select> -->
            </template>
          </vxe-table-column>
          <vxe-table-column field="weight" title="权重" :edit-render="{autofocus: '.el-textarea__inner', enabled: disabled}">
            <template #edit="{ row }">
              <el-autocomplete v-model="row.weight" :fetch-suggestions="querySearchWeight" readonly></el-autocomplete>
              <!-- <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.weight"></el-input> -->
            </template>
          </vxe-table-column>
          <vxe-table-column field="wholeTarget" title="总目标" :edit-render="{autofocus: '.el-textarea__inner', enabled: disabled}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.wholeTarget"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="finishDate" title="总目标完成时间" width="135" :edit-render="{autofocus: '.el-textarea__inner', enabled: disabled}">
            <template #edit="{ row }">
              <el-date-picker v-model="row.finishDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
            </template>
            <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>
          <vxe-table-column field="currentWeekTarget" width="105" :title="`${summaryData.week||''}周需达到的目标`" :edit-render="{autofocus: '.el-textarea__inner', enabled: disabled}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.currentWeekTarget"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="currentWeekFinishDate" :title="`${summaryData.week||''}周目标完成日期`" width="135" :edit-render="{autofocus: '.el-textarea__inner', enabled: disabled}">
            <template #edit="{ row }">
              <el-date-picker v-model="row.currentWeekFinishDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
            </template>
            <template #default="{ row }">{{ formatDate(row.currentWeekFinishDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>
           <vxe-table-column field="isImportantWork" title="重点关注" :edit-render="{name: 'ElSelect',autofocus: '.el-input__inner', enabled: disabled}">
            <template #default="{row}">
              <span v-if='row.isImportantWork == 0'>否</span>
              <span v-if='row.isImportantWork == 1'>是</span>
            </template>
            <template #edit="scope">
              <el-select v-model="scope.row.isImportantWork" @change="$refs.planMonth.updateStatus(scope)">
                <el-option v-for="item in importantList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remark" title="备注" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.remark"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态">
            <template #default="{ row }">
              <el-tag
                v-if='row.status === 0'
                type="complete"
                effect="dark">
                已保存
              </el-tag>
              <el-tag
                v-if='row.status === 10'
                type="complete"
                effect="dark">
                已提交
              </el-tag>
              <el-tag
                v-if='row.status === 20'
                type="complete"
                effect="dark">
                已发布
              </el-tag>
            </template>
          </vxe-table-column>
          <vxe-table-column field="" title="操作" fixed width='180' class-name='operation'>
            <template #default="scope">
              <div v-if='scope.row.status === 0 || scope.row.status === 30 || scope.row.status === 100'>
                <el-tooltip class='item' effect='dark' content='发布' placement="bottom">
                  <i class='icon-send' @click='singleSubmit(scope.row)'></i>
                </el-tooltip>
                <el-tooltip class='item' effect='dark' content='新增' placement="bottom">
                  <i class='icon-add' @click='addRow(scope.rowIndex)'></i>
                </el-tooltip>
                <el-tooltip class='item' effect='dark' content='删除' placement="bottom">
                  <i class='icon-close delete' @click='deleteData(scope.row, scope.rowIndex)'></i>
                </el-tooltip>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div v-if="currentTab === 1" class='table-content atb-flex atb-flex-column'>
        <vxe-table
          class='atb-table header-table edit-table'
          border='full'
          height='100%'
          auto-resize
          resizable
          :data="noPlanTableData"
          ref="noPlanYear"
          @checkbox-change="selectNoPlanData"
          @checkbox-all="selectAllNoPlanData"
          :edit-config="{trigger: 'click', mode: 'row'}"
          @edit-closed="noPlanEditClosed"
        >
          <vxe-table-column type='checkbox' width='40' align='center'></vxe-table-column>
          <vxe-table-column type='seq' width='48' align='center' title="序号"></vxe-table-column>
          <!-- <vxe-table-column field="workItemNo" title="NO." :edit-render="{autofocus: '.el-textarea__inner', enabled: disabled}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.workItemNo"></el-input>
            </template>
          </vxe-table-column> -->
          <vxe-table-column field="workClassify" title="工作属性" :edit-render="{name: 'ElSelect', enabled: disabled, autofocus: '.el-input__inner'}">
            <template #default="{row}">
              <span v-if='row.workClassify == 60'>其他新增工作</span>
            </template>
            <template #edit="scope">
              <el-select v-model='scope.row.workClassify' @change="$refs.week.updateStatus(scope)">
                <el-option v-for="item in classifyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemCategory" title="类别" :edit-render="{name: 'ElSelect', enabled: disabled, autofocus: '.el-input__inner'}">
            <template #edit="scope">
              <el-select v-model='scope.row.workItemCategory' @change="$refs.week.updateStatus(scope)">
                <el-option v-for="item in categoryList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemContent" title="工作项目" :edit-render="{name: 'ElAutocomplete', enabled: disabled, autofocus: '.el-input__inner'}">
            <template #edit="{ row }">
              <el-autocomplete v-model="row.workItemContent" :fetch-suggestions="querySearch"></el-autocomplete>
            </template>
            <template #default="scope">
              <template>
                <span>{{scope.row.workItemContent}}</span>
              </template>
            </template>
          </vxe-table-column> 
          <vxe-table-column field="resWkName" title="指定人" :edit-render="{autofocus: '.el-textarea__inner', enabled: disabled}">
            <template #edit="{ row }">
              <selecter v-model="row.resWkNo" @selecterData="getSelecterData" :jobNo="row.resWkNo" :name="row.resWkName"></selecter>
              <!-- <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.resWkName"></el-input> -->
            </template>
          </vxe-table-column>
          <vxe-table-column v-if="currentTab === 0" field="weight" title="权重" :edit-render="{autofocus: '.el-textarea__inner', enabled: disabled}">
            <template #edit="{ row }">
              <el-autocomplete v-model="row.weight" :fetch-suggestions="querySearchWeight"></el-autocomplete>
              <!-- <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.weight"></el-input> -->
            </template>
          </vxe-table-column>
          <vxe-table-column field="wholeTarget" title="总目标" :edit-render="{autofocus: '.el-textarea__inner', enabled: disabled}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.wholeTarget"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="finishDate" title="总目标完成时间" width="135" :edit-render="{autofocus: '.el-textarea__inner', enabled: disabled}">
            <template #edit="{ row }">
              <el-date-picker v-model="row.finishDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
            </template>
            <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>
          <vxe-table-column field="currentWeekTarget"  width="100" :title="`${summaryData.week||''}周需达到的目标`" :edit-render="{autofocus: '.el-textarea__inner', enabled: disabled}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.currentWeekTarget"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="currentWeekFinishDate" :title="`${summaryData.week||''}周目标完成时间`" width="135" :edit-render="{autofocus: '.el-textarea__inner', enabled: disabled}">
            <template #edit="{ row }">
              <el-date-picker v-model="row.currentMonthFinishDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
            </template>
            <template #default="{ row }">{{ formatDate(row.currentWeekFinishDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>
          <vxe-table-column field="isImportantWork" title="重点关注" :edit-render="{name: 'ElSelect',autofocus: '.el-input__inner', enabled: disabled}">
            <template #default="{row}">
              <span v-if='row.isImportantWork == 0'>否</span>
              <span v-if='row.isImportantWork == 1'>是</span>
            </template>
            <template #edit="scope">
              <el-select v-model="scope.row.isImportantWork" @change="$refs.noPlanYear.updateStatus(scope)">
                <el-option v-for="item in importantList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remark" title="备注" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.remark"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态">
            <template #default="{ row }">
              <el-tag
                v-if='row.status === 0'
                type="complete"
                effect="dark">
                已保存
              </el-tag>
              <el-tag
                v-if='row.status === 10'
                type="complete"
                effect="dark">
                已提交
              </el-tag>
              <el-tag
                v-if='row.status === 20'
                type="complete"
                effect="dark">
                已发布
              </el-tag>
            </template>
          </vxe-table-column>
          <vxe-table-column field="" title="操作" fixed width='180' class-name='operation'>
            <template #default="scope">
              <div v-if='scope.row.status === 0 || scope.row.status === 30 || scope.row.status === 100'>
                <el-tooltip class='item' effect='dark' content='保存' placement="bottom">
                  <i class='icon-send' @click='singleSubmit(scope.row)'></i>
                </el-tooltip>
                <el-tooltip class='item' effect='dark' content='新增' placement="bottom">
                  <i class='icon-add' @click='addRow(scope.rowIndex)'></i>
                </el-tooltip>
                <el-tooltip class='item' effect='dark' content='删除' placement="bottom">
                  <i class='icon-close delete' @click='deleteData(scope.row, scope.rowIndex)'></i>
                </el-tooltip>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </div>
    <el-dialog title="新增" :visible.sync="showSelect" width="480px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <ul class='atb-flex atb-flex-justify-between '>
          <li @click="isTableInner = 1" :class='["atb-flex","atb-flex-items-center", isTableInner === 1 ? "active" : ""]'>
            <div>
              <h2>表格内新增</h2>
              <p>直接填写新增内容</p>
            </div>
          </li>
          <li @click="isTableInner = 2" :class='["atb-flex","atb-flex-items-center", isTableInner === 2 ? "active" : ""]'>
            <div>
              <h2>计划同步新增</h2>
              <p>选择计划内的内容发布任务</p>
            </div>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="confirm">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showSelect = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="计划同步新增" v-if="showPlanAdd" destroy-on-close class="plan-dialog" :visible.sync="showPlanAdd" width="900px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <vxe-table
          class='atb-table header-table edit-table'
          border='full'
          height='100%'
          auto-resize
          resizable
          :data="monthTableData"
          ref="monthPlanData"
          :row-class-name="setRowClass"
          :merge-cells="mergeCells"
          @checkbox-change="handledSelectChange"
          @checkbox-all="selectAllEvent"
        >
          <vxe-table-column type='checkbox' width='40' align='center'>
            <template #checkbox="scope">
                <template v-if="scope.rowIndex === 0">
               <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <span>KPI工作</span>
                </div>
              </template>
              <template v-else-if="scope.rowIndex === kpiLength + 1">
               <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <span>例行工作</span>
                </div>
              </template>
              <template v-else-if="scope.rowIndex === kpiLength + normalLength + 2">
               <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <span>问题及创新工作</span>
                </div>
              </template>
              <template v-else-if="scope.rowIndex === kpiLength + normalLength + createLength + 3">
               <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <span>其他新增工作</span>
                </div>
              </template>
              <template v-else>
                <span title="选择/取消" :class="['vxe-cell--checkbox', scope.checked ? 'is--checked' : '']" @click.stop="selectSingle(scope.row)">
                  <span class="vxe-checkbox--icon vxe-checkbox--checked-icon"></span>
                  <span class="vxe-checkbox--icon vxe-checkbox--unchecked-icon"></span>
                  <span class="vxe-checkbox--icon vxe-checkbox--indeterminate-icon"></span>
                </span>
              </template>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemNo" title="NO."></vxe-table-column>
          <vxe-table-column field="workItemCategory" title="类别"></vxe-table-column>
          <vxe-table-column field="workItemContent" width="80" title="工作项目" :edit-render="{name: 'ElAutocomplete', enabled: disabled, autofocus: '.el-input__inner'}">
          </vxe-table-column>
          <vxe-table-column field="resWkName" title="指定人" :edit-render="{autofocus: '.el-textarea__inner', enabled: disabled}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.resWkName"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column v-if="currentTab === 0" field="weight" title="权重">
          </vxe-table-column>
          <vxe-table-column field="wholeTarget" title="总目标">
          </vxe-table-column>
          <vxe-table-column field="finishDate" width="105" title="总目标完成时间">
            <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>
           <vxe-table-column field="currentWeekTarget" width="90" :title="`${summaryData.week||''}周需达到的目标`">
          </vxe-table-column>
          <vxe-table-column field="currentWeekFinishDate" width="95" :title="`${summaryData.week||''}周目标完成时间`">
            <template #default="{ row }">{{ formatDate(row.currentWeekFinishDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>
          <vxe-table-column field="isImportantWork" width="105" title="重点关注">
            <template #default="{ row }">{{ row.isImportantWork?'是':'否' }}</template>
          </vxe-table-column>
          </vxe-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="addYearPlan">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showPlanAdd = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import XEUtils, { isArray } from 'xe-utils'
  import _ from 'lodash';

  export default {
    components: {
     selecter:()=>import('@/component/global/customerSelect')
    },
    name: "index",
    data() {
      return {
        workId: '',
        tabList: [
          {
            label: '进入周计划表',
            id: 0,
          },
          {
            label: '不进入周计划表',
            id: 1,
          },
        ],
        currentTab: 0,
        showSelect: false,
        showPlanAdd: false,
        handleDelete: true,
        isTableInner: 1,

        searchParam: {
          WorkItemCategory: null,
          WorkClassify: null,
          KeyWord: null,
          CompleteStatus: null
        },

        disabled: true,
        allowEdit: true,
        result: {},
        kpi: [],
        normal: [],
        create: [],
        other: [],
        mergeCells: [
          {row: 0, col: 0, rowspan: 1, colspan: 11},
          {row: 1, col: 0, rowspan: 1, colspan: 11},
          {row: 2, col: 0, rowspan: 1, colspan: 11},
          {row: 3, col: 0, rowspan: 1, colspan: 11}
        ],
        classifyList: [
          {label: 'KPI工作', value: 0},
          {label: '例行工作', value: 10},
          {label: '问题及创新工作', value: 20},
          {label: '其他新增工作', value: 30},
        ],
        categoryList: [
          {value: '前端'},
          {value: '后端'}
        ],
        completeList: [
          {label: '计划', value: 0},
          {label: '进行中', value: 10},
          {label: '已完成', value: 20},
          {label: '延迟', value: 30},
          {label: '转移', value: 40},
          {label: '暂停或关闭', value: 50},
        ],
        importantList: [
          {label: '否', value: 0},
          {label: '是', value: 1},
        ],
        programList: [
          {"value": "A2000plus"},
          {"value": "A1000plus"},
          {"value": "远程项目"},
        ],
        unHandleList: [],
        handledList: [],
        allChecked: false,
        programData: [
          {id: 10001, name: '戴永明', address: 'A2000plus项目界面设计完成,前端样式验收保质保量', date: '2021/04/19-2021/04/20'},
          {id: 10002, name: '戴永明', address: 'A2000plus项目界面设计完成,前端样式验收保质保量', date: '2021/04/19-2021/04/20'},
          {id: 10003, name: '戴永明', address: 'A2000plus项目界面设计完成,前端样式验收保质保量', date: '2021/04/19-2021/04/20'},
          {id: 10004, name: '戴永明', address: 'A2000plus项目界面设计完成,前端样式验收保质保量', date: '2021/04/19-2021/04/20'},
          {id: 10005, name: '戴永明', address: 'A2000plus项目界面设计完成,前端样式验收保质保量', date: '2021/04/19-2021/04/20'}
        ],
        checkList: [],
        selectAllProgram: false,
        isChecked: false,
        status: 0,
        idList: [],
        tableData:[],
        noPlanTableData:[],
        record:{
              workClassify: 0,
              workItemNo: "",
              workItemCategory: "",
              workItemContent: "",
              resWkNo: "",
              resWkName: "",
              wholeTarget: "",
              finishDate: "",
              currentMonthTarget: "",
              currentMonthFinishDate: "",
              isImportantWork:0,
              status: null,
              remark: ""
        },
        resWk:[],
        summaryData:{},
        seleterData:[],
        weightList:[
          {"value": 5},
          {"value": 10},
          {"value": 15},
          {"value": 20},
          {"value": 25},
        ]
      }
    },
    computed: {
      kpiLength() { //kpi数据长度 动态增加数据使用
        return this.kpi.length;
      },
      normalLength() {
        return this.normal.length;
      },
      createLength() {
        return this.create.length;
      },
      otherLength() {
        return this.other.length;
      },
      monthTableData() {
        return [{}, ...this.kpi, {}, ...this.normal, {}, ...this.create, {}, ...this.other];
      }
    },
    created() {
      this.workId = this.$route.query.id || '';
      this.status = parseInt(this.$route.query.status) || 0;
      this.getList();
      this.getUsers();
    },
    mounted() {

    },
    methods: {
      getCurrent(item) {
        this.currentTab = item.data.id;
      },
      getList() {
          if (!this.workId)
          return
          let param = Object.assign({WorkId: this.workId}, this.searchParam, {IntoPlanList: -1, WorkClassify:-1})
          this.$ajax.get(this.$api.add.week.weekWorkDetail.list, param).then((res) => {
          res.data&&this.filterTableData(res.data.details);
          this.summaryData=res.data&&res.data.plan||{};
        });
      },
      addData() {
        this.showSelect = true;
      },
      async confirm() {
        this.showSelect = false;
        if (this.currentTab === 0) {
          const now = this.$refs.planMonth.getActiveRecord();
          console.log(now);
          if (this.isTableInner === 1) {
            //表格内新增
            const $table = this.$refs.planMonth;
            const {row: newRow} = await $table.insertAt(Object.assign({},this.record,{ weight: 0 }) , -1);
            await $table.setActiveRow(newRow);
          } else {
            this.showPlanAdd = true;
            this.getWeekWorkList();
          }
        } else {
          if (this.isTableInner === 1) {
            //表格内新增
            const $table = this.$refs.noPlanYear;
            const {row: newRow} = await $table.insertAt(this.record, -1);
            await $table.setActiveRow(newRow);
          } else {
            this.showPlanAdd = true;
            this.getWeekWorkList();
          }
        }

      },
      getWeekWorkList() {
        this.$ajax.get(this.$api.week.WeekWorkDetail.list,{}).then((res) => {
          res.data&&this.filterSyncTableData(res.data.detailDtoList);
          if (!res.data) {
            this.monthTableData = [{}, {}, {}, {}];
          }
        });
      },
      filterTableData(data) {
        if(isArray(data)){
        this.tableData = data.filter(val => val.intoPlanList == 1);
        this.noPlanTableData = data.filter(val => val.intoPlanList == 0);
        this.tableData.length>0? this.tableData: this.tableData.push(Object.assign({},this.record,{ weight: 0 }));
        this.noPlanTableData.length>0? this.noPlanTableData: this.noPlanTableData.push(this.record);
        }else{
        this.tableData.push(Object.assign({},this.record,{ weight: 0 }));
        this.noPlanTableData.push(this.record);
        }
      },
      filterSyncTableData(data) {
        if(isArray(data)){
        this.kpi = data.filter(val => val.workClassify == 0);
        this.normal = data.filter(val => val.workClassify == 10);
        this.create = data.filter(val => val.workClassify == 20);
        this.other = data.filter(val => val.workClassify == 30);
        }
      },
      selectAllEvent({records}) {
        let data = records.filter(val => val.workId !== undefined);
        this.idList = data.map(val => {
          const {id} = val;
          return {id: id, workId: this.workId};
        });
      },
      handledSelectChange({records}) {
        this.idList = records.map(val => {
          const {id} = val;
          return {id: id, workId: this.workId};
        });
      },
      selectNoPlanData({records}) {
        let data = records.filter(val => val.workId !== undefined);
        this.idList = data.map(val => {
          const {id} = val;
          return {id: id, workId: this.workId};
        });
      },
      selectAllNoPlanData({records}) {
        this.idList = records.map(val => {
          const {id} = val;
          return {id: id, workId: this.workId};
        });
      },
      selectSingle(row) {
        this.$refs.monthPlanData.toggleCheckboxRow(row);
      },
      setRowClass({rowIndex}) {
        if (rowIndex == 0 || rowIndex == this.kpiLength + 1 || rowIndex == this.kpiLength + this.normalLength + 2 || rowIndex == this.kpiLength + this.normalLength + this.createLength + 3) {
          return 'main-row';
        }
      },
      formatDate(value, format) {
        return XEUtils.toDateString(value, format)
      },
      save(row,index) {
        row.resWkName=row.resWkNo? this.seleterData.find(t=>t.jobNo==row.resWkNo).name: '';
        row.status=row.status? row.status: 0;
        this.$ajax.post(this.$api.add.week.weekWorkDetail.adu, [row]).then((res) => {
          if(res.code==0){
            const item = res.data[0]||{};
            if(item.intoPlanList==1){
              this.tableData.splice(index, 1, item)
            }else{
              this.noPlanTableData.splice(index, 1, item)
            }
            this.$message.success('保存成功');
          }
        });
      },
      editClosed({ row, $rowIndex }) {
        if ($rowIndex !== -1) {
          if (this.status === 0 || row.status === 20 || this.status === 30 || row.status === 40 || this.status === 50) {
            this.save(Object.assign({},row,{ intoPlanList: 1 }, {workId: this.workId}) , $rowIndex);
          }
        }
      },
      noPlanEditClosed({row, $rowIndex}) {
        if ($rowIndex !== -1) {
          if (this.status === 0 || row.status === 20 || this.status === 30 || row.status === 40 || this.status === 50) {
            this.save(Object.assign({},row,{ intoPlanList: 0 }, {workId: this.workId}) , $rowIndex);
          }
        }
      },
      querySearch(queryString, cb) {
        let programList = this.programList;
        // 调用 callback 返回建议列表的数据
        cb(programList);
      },
      deleteData(row,index) {
        if(row.intoPlanList===1){
          this.tableData.splice(index, 1);
        }else{
          this.noPlanTableData.splice(index, 1);
        }
        if (row.id) {
          this.$ajax.delete(this.$api.add.week.weekWorkDetail.adu + '/' + row.id).then((res) => {
            if(res.code===0){
              this.$message.success('删除成功');
            }else{
              this.$message.error(res.message);
            }
          });
        }
      },
      submit() {
        if(this.currentTab === 0) {
          this.$ajax.put(this.$api.add.week.weekWorkDetail.submit, `"${this.workId}"`, { headers: { 'Content-Type': 'application/json;charset=UTF-8;' } }).then((res) => {
            if(res.code===0){
              this.$message.success('提交成功');
              this.getList();
            }else{
              this.$message.error(res.message);
            }
          });
        }else {
          this.$ajax.put(this.$api.add.week.weekWorkDetail.submit, `"${this.workId}"`, { headers: { 'Content-Type': 'application/json;charset=UTF-8;' } }).then((res) => {
            if(res.code===0){
              this.$message.success('提交成功');
              this.getList();
            }else{
              this.$message.error(res.message);
            }

          });
        }
      },
      complete(row, rowIndex, status) {
        let res = status === "access" ? 50 : 40;
        this.$ajax.put(this.$api.week.weekWorkDetail.updateStatus, [{
          id: row.id,
          status: res,
          workId: this.workId
        }]).then((res) => {
          if(res===0){
            this.$message.success('审批成功');
          }else{
            this.$message.error(res.message);
          }
        });
      },
      addYearPlan() {
        let check = this.$refs.monthPlanData.getCheckboxRecords();
        let data = check.filter(val => val.workId !== undefined);
        if(this.currentTab===0){
          data.map(val=>{
            const obj= _.cloneDeep(this.record);
              obj.workClassify= val.workClassify,
              obj. workItemNo= val. workItemNo,
              obj.workItemCategory= val.workItemCategory,
              obj.workItemContent= val.workItemContent,
              obj.resWkNo= val.resWkNo,
              obj.resWkName= val.resWkName,
              obj.weight= 0,
              obj.wholeTarget= val.wholeTarget,
              obj.finishDate= val.finishDate,
              obj.currentWeekTarget= val.currentWeekTarget,
              obj.currentWeekFinishDate=val.currentWeekFinishDate,
              obj.isImportantWork=val.isImportantWork,
              obj.remark= val.remark
            this.tableData.splice(this.tableData.length, 0, obj);
          });
        }else{
          data.map(val=>{
             const obj= _.cloneDeep(this.record);
              obj.workClassify= val.workClassify,
              obj. workItemNo= val. workItemNo,
              obj.workItemCategory= val.workItemCategory,
              obj.workItemContent= val.workItemContent,
              obj.resWkNo= val.resWkNo,
              obj.resWkName= val.resWkName,
              obj.wholeTarget= val.wholeTarget,
              obj.finishDate= val.finishDate,
              obj.currentWeekTarget= val.currentWeekTarget,
              obj.currentWeekFinishDate=val.currentWeekFinishDate,
              obj.isImportantWork=val.isImportantWork,
              obj.remark= val.remark
             this.noPlanTableData.splice(this.noPlanTableData.length, 0, obj);
          });
        }
        this.showPlanAdd=false;
      },
      async addRow(index) {
        const item = _.cloneDeep(this.record);
        this.showSelect = false;
        if (this.currentTab === 0) {
             this.tableData.splice(index + 1, 0,Object.assign({},item,{weight: 0},{intoPlanList: 1}));
            const $table = this.$refs.planMonth;
            await $table.setActiveRow(this.tableData[index + 1]);
        } else {
            this.noPlanTableData.splice(index + 1, 0, Object.assign({},item,{intoPlanList: 0}));
            const $table = this.$refs.noPlanYear;
            await $table.setActiveRow(this.noPlanTableData[index + 1]);
          }
      },
      getUsers(){
        this.$ajax.post(this.$api.sys.userInfo.list,{maxResultCount:30, skipCount:0, userSourceType:[3]}).then((res) => {
             this.resWk=res.items||[];
         });
      },
      singleSubmit(row){
       const status=20;
       this.$ajax.put(this.$api.add.week.weekWorkDetail.updateStatus, [{
          id: row.id,
          workId: this.workId,
          status: status
        }]).then((res) => {
          if(res.code==0){
            this.$message.success('提交成功');
            this.getList();
          }else{
            this.$message.error(res.message);
          }
        });
      },
      getSelecterData(data){
        this.seleterData=data;
      },
      querySearchWeight(queryString, cb) {
        let weightList = this.weightList;
        // 调用 callback 返回建议列表的数据
        cb(weightList);
      }
    },
    watch: {
      monthTableData: {
        handler() {
          this.mergeCells = [
            {row: 0, col: 0, rowspan: 1, colspan: 11},
            {row: this.kpiLength + 1, col: 0, rowspan: 1, colspan: 11},
            {row: this.kpiLength + this.normalLength + 2, col: 0, rowspan: 1, colspan: 11},
            {row: this.kpiLength + this.normalLength + this.createLength + 3, col: 0, rowspan: 1, colspan: 11},
          ];
        }
      }
    }
  }
</script>
<style scoped lang='scss'>
  .week {
    height: 100%;
    .header {
      padding-left: 36px;
       .year-no {
        font-weight: bold;
        font-size: 36px;
        color: $--color-primary;
        padding-right: 36px;
        border-right: 1px solid #eaeef4;
      }
      .week-title {
        border-right: 1px solid #eaeef4;
        padding: 0 36px;
        h2 {
          color: $--color-text-primary;
          font-size: 18px;
          font-weight: bold;
        }
        p {
          color: #8e9694;
          margin-top: 16px;
        }
      }
      .week-right {
        flex: 1 1 auto;
        padding-left: 36px;
        .week-name {
          h2 {
            color: $--color-text-primary;
            font-size: 18px;
            font-weight: bold;
            span {
              font-size: 14px;
              font-weight: normal;
              color: #8e9694;
            }
          }
          p {
            color: $--color-text-primary;
            font-size: 14px;
            margin-top: 16px;
          }
        }
        .week-operation {
          .atb-input {
            .el-form-item {
              margin-bottom: 0;
            }
          }
        }
      }
    }
    .container {
      margin-top: 15px;
      padding: 24px;
      flex: 1;
      .kpi-content {
        overflow: auto;
        flex-grow: 1;
      }
    }
    ::v-deep .header-table {
      overflow: auto;
      flex-grow: 1;
      .vxe-table--header-wrapper {
        background-color: $--bg-color-complete !important;
      }
      .main-row {
        .vxe-body--column {
          padding: 0;
        }
        .vxe-cell {
          padding: 0;
        }
      }
    }
    .kpi-add {
      height: 48px;
      background-color: $--color-bg-table-header;
      color: $--color-primary;
      font-size: 14px;
      margin-top: -1px;
      padding: 0 15px;
      span {
        cursor: pointer;
      }
    }
    ::v-deep .el-dialog__body {
      .content {
        text-align: left;
        li {
          height: 120px;
          width: 206px;
          border-radius: 16px;
          background-color: #f6fbfc;
          border: 2px solid #eaeef4;
          padding-left: 20px;
          &.active {
            border-color: $--color-primary;
            background-color: #ddf5f0;
            h2, p {
              color: $--color-primary;
            }
          }
          h2 {
            color: #3d4342;
            font-size: 18px;
            font-weight: bold;
          }
          p {
            color: #859291;
            font-size: 14px;
            margin-top: 14px;
          }
        }
      }
    }
    .plan-dialog {
      .content {
        height: 500px;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: right;
    }
  }

</style>